import { TOKEN_IProjectEventGenerator, type IProjectEventGenerator } from "@/services/ProjectEventGenerator";
import { injectable, inject } from "tsyringe";
import { makeAutoObservable } from "mobx";
import { ProjectAccessStore, TOKEN_ProjectAccessStore } from "../utility-stores/ProjectAccessStore";
import { numberToRgbaString } from "@/lib/utils";

@injectable()
export default class SquareStore {
    init = (x: number, y: number) => {
        this._x = x;
        this._y = y;
        this._color = numberToRgbaString(0);
    }
    public get id() {
        return `${this._x}_${this._y}`;
    }

    private _x: number = 0;
    public get x(): number {
        return this._x;
    }
    public set x(value: number) {
        this._x = value;
    }
    private _y: number = 0;
    public get y(): number {
        return this._y;
    }
    public set y(value: number) {
        this._y = value;
    }
    private _color: string = numberToRgbaString(0);

    public set rgbaString(value: string) {
        this._color = value;
    }

    public get rgbaString(): string {
        return this._color;
    }

    constructor(
        @inject(TOKEN_IProjectEventGenerator) private projectEventGenerator: IProjectEventGenerator,
        @inject(TOKEN_ProjectAccessStore) private readonly projectAccessStore: ProjectAccessStore,
    ) {
        makeAutoObservable(this);
    }

    setColor = async (e: React.MouseEvent) => {
        if (!this.projectAccessStore.currentProjectId || this.projectAccessStore.isUIReadOnly) return;

        await this.projectEventGenerator.setColor(
            this.projectAccessStore.currentProjectId,
            this._x,
            this._y,
            e.button !== 0
        );
    }
}